import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from "@mui/material";
import { AxiosError } from "axios";
import { useAtom } from "jotai";
import { ChangeEvent, FC, useState } from "react";
import { modalDocumentGroup } from "../../../atoms/atom";
import { useUtils } from "../../../utils/utilFunctions";
import { useAlert } from "../../contextProviders/AlertProvider";

const CreateGroupModal: FC<{ create: (cnpj: string) => Promise<any>; cnpjs: string[] }> = ({ create, cnpjs }) => {
	const [cnpj, setCnpj] = useState('');
	const [open, setOpen] = useAtom(modalDocumentGroup);
	const { showAlert, showError } = useAlert();
	const { validateCNPJ, formatDocument, validateCPF } = useUtils();

	return (
		<Dialog
			open={open}
			onClose={() => setOpen(false)}
			id='modal-forms'
		>
			<DialogTitle>Novo grupo</DialogTitle>
			<DialogContent id="modal-forms-content">
				<TextField
					sx={{width: '300px !important'}}
					label="CFP/CNPJ da matriz"
					id="cnpj-form"
					size="medium"
					inputProps={{ maxLength: 18}}
					value={cnpj}
					onChange={(e: ChangeEvent<HTMLInputElement>) => setCnpj(formatDocument(e.target.value.trim()))}
					helperText="Insira o CPF/CNPJ da matriz da empresa"
				/>
			</DialogContent>
			<DialogActions>
				<Button id="close-form-button" onClick={() => setOpen(false)}>
					Fechar
				</Button>
				<Button
					disabled={!validateCNPJ(cnpj) && !validateCPF(cnpj)}
					id="create-form-button"
					color="success"
					onClick={() => save()}
				>
					Salvar
				</Button>
			</DialogActions>
		</Dialog>
	);

	async function save() {
		if (cnpjs.includes(cnpj)) {
			showError("Grupo já cadastrado com este CNPJ/CPF");
			setCnpj('');
			setOpen(false);
			return;
		}
		try {
			const response = await create(cnpj);
			if (response.status === 200) {
				showAlert('Formulário criado com sucesso', "success");
				setOpen(false);
			}
		} catch (error) {
			if (!(error instanceof AxiosError && error.response)) return;
			switch (error.response?.status) {
				case 404:
					showError("Nenhuma empresa encontrada para o CNPJ");
					break;
				case 406:
					showError("A empresa deste CNPJ não é a matriz!");
					break;
				default:
					showError();
					break;
			}
		}
		setCnpj('');
	}
}

export default CreateGroupModal;